export const columnLayout = (popCameraRecord, popSnapshot) => {
  const gridColumnLayOut = [
    {
      dataField: "inspno",
      headerText: "검수번호",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "tmsodrno",
      headerText: "배차번호",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "odrTypeNm",
      headerText: "배차구분",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "plantcd",
      headerText: "공장코드",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "plantnm",
      headerText: "공장명",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "vndrnm",
      headerText: "공급업체",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "rvndrnm",
      headerText: "실공급업체",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "vhclno",
      headerText: "차량번호",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "inspRmks",
      headerText: "검수원비고",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "inspdt",
      headerText: "입고일자",
      dataType: "date",
      formatString: "yyyy-mm-dd",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "arrvdt",
      headerText: "도착시간",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "inweighdt",
      headerText: "입차시간",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "outweighdt",
      headerText: "출차시간",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "weightPlace",
      headerText: "계근대",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "inweight",
      headerText: "입차중량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "outweight",
      headerText: "출차중량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "realweight",
      headerText: "계근중량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "outagewght",
      headerText: "감량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "outagenm",
      headerText: "감량사유",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      styleFunction: function (
          rowIndex,
          columnIndex,
          value,
          headerText,
          item,
          dataField
      ) {
        if (item.outageRsnFlag === "Y") {
          return "my-cell-style1";
        }
        return null;
      },
    },
    {
      dataField: "totalweight",
      headerText: "입고중량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "returnnm",
      headerText: "반품구분",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "returnrsn",
      headerText: "반품사유",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "scrapAreaCd",
      headerText: "하차지역",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "scrapareanm",
      headerText: "하차지역",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "workernm",
      headerText: "검수자",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "preitemnm",
      headerText: "사전등급",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "inspitemnm",
      headerText: "검수등급",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "dcsnitemnm",
      headerText: "확정등급",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "scoreitemnm",
      headerText: "스코어등급",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "mov",
      headerText: "녹화유무",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      renderer: {
        type: "ButtonRenderer",
        labelText: "영상",
        onClick: popCameraRecord,
        visibleFunction: function (
          rowIndex,
          columnIndex,
          value,
          item,
          dataField
        ) {
          if (item.mov === "Y") {
            return true;
          }
          return false;
        },
      },
    },
    {
      dataField: "pic",
      headerText: "사진유무",
      filter: {
        showIcon: true,
        useExMenu: true,
      },

      renderer: {
        type: "ButtonRenderer",
        labelText: "스냅샷",
        onClick: popSnapshot,
        visibleFunction: function (
          rowIndex,
          columnIndex,
          value,
          item,
          dataField
        ) {
          if (item.pic === "Y") {
            return true;
          }
          return false;
        },
      },
    },

    {
      dataField: "subitemnm1",
      headerText: "세부1",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "subitemprd1",
      headerText: "세부명1",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "subitemrate1",
      headerText: "세부1비율",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "subitemnm2",
      headerText: "세부2",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "subitemprd2",
      headerText: "세부명2",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "subitemrate2",
      headerText: "세부2비율",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "subitemnm3",
      headerText: "세부3",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "subitemprd3",
      headerText: "세부3명",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "subitemrate3",
      headerText: "세부3비율",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "transcd",
      headerText: "국내/해상",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "scrapgbn",
      headerText: "고철구분",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "loadarea",
      headerText: "상차지역",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "leadTime",
      headerText: "리드타임",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
  ];
  return gridColumnLayOut;
};
